import ApiContext from '@context/ApiContext';
import { use } from 'react';
import { ApiClients } from 'types/ApiProvider.types';

/**
 * Custom hook to access API clients from the ApiContext.
 * @returns {ApiClients} The API clients.
 * @throws {Error} If the API clients are not initialized.
 */
const useApiClients = (): ApiClients => {
  const apiContext = use(ApiContext);

  if (!apiContext) {
    throw new Error('useApiClients must be used within an ApiProvider');
  }

  // As ApiGuard exists, API clients should be initialized by this point
  if (!apiContext.isInitialized) {
    throw new Error('API clients are not initialized');
  }
  return apiContext.apiClients!;
};

export default useApiClients;
